import * as R from 'ramda';
import { OrderItem } from '../order-item';
import { getProductVariantIdFromMetadata } from './getProductVariantIdFromMetadata';

export const getProductVariantIdsFromOrderItems = (orderItems: OrderItem[]): string[] => {
  if (!orderItems) {
    return [];
  }

  const productVariantIds: string[] = R.map(
    (loopItem: OrderItem) => getProductVariantIdFromMetadata(loopItem.metadata),
    orderItems,
  );

  const notEmptyProductVariantIds: string[] = R.filter(
    (loopProductVariantId: string) => Boolean(loopProductVariantId),
    productVariantIds,
  );

  return R.uniq(notEmptyProductVariantIds);
};
